<template>
  <div
    v-if="fields"
    class="content-center pos-rel"
    :class="{ 'primary': fields.blockDisplay || (fields.slantedBackground && smAndDown),
    'py-8': (!fields.slantedBackground),
    'pb-12': fields.slantedBackground && fields.blockDisplay }"
    :style="{ 'margin-top': fields.slantedBackground && !smAndDown ? '60px' : '' }"
  >
    <div
      :class="[
        { 'content-constraint': !fields.blockDisplay || (fields.blockDisplay && !smAndDown) },
        { 'overflow-hidden': fields.blockDisplay && smAndDown }
      ]"
      :style="{ 'margin-top': fields.slantedBackground ? '60px' : '' }"
    >
      <v-row
        class="pos-rel content-row"
        :class="{ 'py-12': !fields.blockDisplay }"
        style="z-index: 1;"
      >
        <div
          v-if="fields.blockDisplay"
          :class="block-image"
          :style="[
            { backgroundImage: `url('${file.url}')` },
            { 'order': fields.heroRight ? '1' : '0' }
          ]"
          alt=""
          role="img"
        />
        <v-col
          v-else
          sm="12"
          md="6"
          class="d-flex justify-center"
          :class="[
            { 'px-6': smAndDown },
            { 'pl-6': !smAndDown && fields.heroRight },
            { 'pr-6': !smAndDown && !fields.heroRight }
          ]"
          :style="{ 'order': fields.heroRight ? '1' : '0' }"
        >
          <img
            v-if="file"
            :src="file.url"
            alt=""
            class="align-center"
            max-width="550"
            min-width="300"
            aspect-ratio="1.7778"
            width="100%"
            :aria-label="file.title"
            role="img"
          />
        </v-col>
        <v-col
          sm="12"
          md="6"
          class="d-flex fx-1 align-center"
          :class="[
            { 'px-10': smAndDown && fields.blockDisplay },
            { 'px-6': smAndDown && !fields.blockDisplay },
            { 'pr-6': !smAndDown && fields.heroRight },
            { 'pl-6': !smAndDown && !fields.heroRight }
          ]"
          style="min-width: 300px;"
          :style="{ 'order': fields.heroRight ? '0' : '1' }"
        >
          <div class="d-flex flex-column text-left">
            <div class="flex-column">
              <h2
                v-if="fields.title && fields.title.length"
                class="mb-3 h3"
                :class="(fields.blockDisplay || fields.slantedBackground) ? 'white--text' : 'secondary--text'"
              >
                {{ fields.title }}
              </h2>
              <ctf-rich-text
                v-if="fields.descriptionRichText"
                class="white-space-pre-line"
                :class="(fields.blockDisplay || fields.slantedBackground) ? 'white--text' : 'secondary--text'"
                :document="fields.descriptionRichText" />
            </div>
            <div class="extra-top-margin d-flex flex-column flex-md-row align-center flex-wrap">
              <ctf-link
                v-if="fields.button"
                :btn-id="fields.button.sys.id"
                class="mt-5 mx-2"
                :inverted="(siteConfig && siteConfig.navBottomBorderColor === 'green')"
                ref="linkButton"
              >
              </ctf-link>
              <ctf-link
                v-if="fields.secondaryButton"
                :btn-id="fields.secondaryButton.sys.id"
                class="mt-5 mx-2"
                :inverted="(siteConfig && siteConfig.navBottomBorderColor === 'green')"
              />
              <div
              class="button-side"
              @click="imageClick">
                <img
                v-if="file && file.buttonImageUrl"
                :src="file.buttonImageUrl"
                alt=""
                class="image-margin"
                max-width="250"
                min-width="200"
                contain
                width="100%"
                :aria-label="buttonImageTitle"
                role="img"
                />
                <p
                v-if="file && file.buttonImageDesc"
                class='white--text'
                style="text-align: center;"
                v-html="file.buttonImageDesc"/>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
    <template v-if="!smAndDown">
      <div
        v-if="fields.slantedBackground"
        class="background first"
        :class="(siteConfig && siteConfig.navBottomBorderColor === 'green') ? 'yellow' : 'gold'"
      />
      <div
        v-if="fields.slantedBackground"
        :class="{ second: fields.slantedBackground }"
        class="background primary"
      />
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { handleLinkClick } from '@/utils/helpers'
import { getCTFAsset } from '@/plugins/contentful'
import CtfLink from '@/components/snippets/ctf-link'

export default {
  name: 'ValueProposition',
  components: {
    CtfLink
  },
  props: {
    fields: {
      type: Object,
      default: null
    },
    assets: {
      type: Array,
      default: null
    }
  },
  computed: {
    ...mapState({ siteConfig: state => state.site.siteConfig }),
    file () {
      if (!this.fields || !this.assets) {
        return
      }
      const { fields } = getCTFAsset(this.fields.heroImage.sys.id, this.assets)
      const buttonImage = this.fields.buttonImage ? getCTFAsset(this.fields.buttonImage.sys.id, this.assets).fields : null
      return fields
        ? {
          url: fields.file.url,
          title: fields.title,
          buttonImageUrl: buttonImage ? buttonImage.file.url : null,
          buttonImageTitle: buttonImage ? buttonImage.title : null,
          buttonImageDesc: buttonImage ? buttonImage.description : null
        } : null
    },
    smAndDown () {
      return this.$vuetify.breakpoint.smAndDown
    }
  },
  methods: {
    handleLinkClick,
    imageClick () {
      if (this.$refs.linkButton) {
        this.$refs.linkButton.handleClick()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../styles/variables";

  .block-image {
    display: flex;
    width: 50%;
    min-height: 300px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }

  .content-row {
    display: flex;

    img {
      object-fit: contain;
    }
  }

  @media only screen and (max-width: $breakpoint-md) {
    .content-row {
      display: block;
    }
  }

  .button-side {
    margin-left: 60px;
    @media only screen and (max-width: $breakpoint-md) {
      margin-left: 0px;
      margin-top: 20px;
      margin-bottom: 20px;
    }
    cursor: pointer;
  }

  .image-margin {
    margin-bottom: 10px;
  }

  .extra-top-margin {
    margin-top: 35px
  }

  .background {
    position: absolute;
    right: 0;
    left: 0;
    top: -60px;
    bottom: 0;
    height: 115%;
    z-index: -1;
  }

  .first {
    clip-path: polygon(0 0, 100% 10vw, 100% 100%, 0% 100%);
  }
  .second {
    clip-path: polygon(0 10vw, 100% 0, 100% 100%, 0% 100%);
  }
  @media only screen and (max-width: $breakpoint-sm) {
    ::v-deep .row {
      margin-left: -17px;
      margin-right: -17px;
    }
    .block-image {
      width: 100%;
    }
    .background {
      top: 0;
    }
  }
</style>
